// constants

import { UserActionTypes } from "./constants";

export interface UserActionType {
  type:
    | UserActionTypes.API_RESPONSE_SUCCESS
    | UserActionTypes.API_RESPONSE_ERROR
    | UserActionTypes.GET_USER_DATA
    | UserActionTypes.BLOCK_USER
    | UserActionTypes.ACTIVATE_USER;

  payload: {} | string;
}

interface UpdateUserStatusPayload {
  userId: string;
  status: string;
}

// common success
export const UsersApiResponseSuccess = (actionType: string, data: any | {}): UserActionType => ({
  type: UserActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const UsersDataApiResponseError = (actionType: string, error: string): UserActionType => ({
  type: UserActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getUserData = (): UserActionType => ({
  type: UserActionTypes.GET_USER_DATA,
  payload: {},
});

export const updateUserStatus = ({ userId, status }: UpdateUserStatusPayload): UserActionType => ({
  type: UserActionTypes.ACTIVATE_USER,
  payload: { userId, status },
});

export const blockUser = (userId: string): UserActionType => ({
  type: UserActionTypes.BLOCK_USER,
  payload: { userId },
});
